/**
 * 微信JSAPI支付工具类
 */
export default class WxPay {
    /**
     * 调起微信支付
     * @param {Object} payParams 后端返回的支付参数
     */
    static async wxPay(payParams) {
        return new Promise((resolve, reject) => {
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', () => {
                        this.onBridgeReady(payParams, resolve, reject)
                    }, false)
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', () => {
                        this.onBridgeReady(payParams, resolve, reject)
                    })
                    document.attachEvent('onWeixinJSBridgeReady', () => {
                        this.onBridgeReady(payParams, resolve, reject)
                    })
                }
            } else {
                this.onBridgeReady(payParams, resolve, reject)
            }
        })
    }

    // 微信支付内核调用
    static onBridgeReady(payParams, resolve, reject) {
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
            appId: payParams.appId,
            timeStamp: payParams.timeStamp,
            nonceStr: payParams.nonceStr,
            package: payParams.package,
            signType: payParams.signType,
            paySign: payParams.paySign
        }, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                resolve("支付成功")
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                reject("用户取消支付")
            } else {
                reject("支付失败：" + res.err_msg)
            }
        })
    }
}